export const ASCII_FACES = [
  '(ツ)',
  '(◕‿◕)',
  '(｡◕‿◕｡)',
  'ʕ•ᴥ•ʔ',
  '(づ｡◕‿‿◕｡)づ',
  '(ᵔᴥᵔ)',
  '(◠‿◠)',
  '(✿◠‿◠)',
  '(◕‿◕✿)',
  'ʕ•́ᴥ•̀ʔ',
  '(ᗒᗣᗕ)՞',
  '(¬_¬)',
  '(ﾟ∩ﾟ)',
  '(♡´艸`)',
  '( ๑ ❛ ڡ ❛ ๑ )❤',
  '(>_<)',
  '(>w<)',
  '(^_^;)',
  '(-_-;)',
  '(~_~;)',
  '(・.・;)',
  '(・_・;)',
  '(・・;)',
  '^^;',
  '^_^;',
  '(#^.^#)',
  '(^;)',
  '(-.-)y-°°°',
  '(^_-)-☆',
  '(+o+)',
  '(°°)',
  '(°-°)',
  '(°.°)',
  '(°_°)',
  '(°_°>)',
  '(°レ°)',
  '(°o°)',
  '(^_^)/',
  '(^O^)／',
  '(^o^)／',
  '(^^)/',
  '(≧∇≦)/',
  '(/◕ヮ◕)/',
  '(^o^)丿',
  '∩(·ω·)∩',
  '(·ω·)',
  '^ω^',
  '_(._.)_',
  '_(_^_)_',
  '<(_ _)',
  '<m(__)m>',
  'm(__)m',
  'm(_ _)m',
  '(／ロ°)／',
  '(/_;)',
  '(T_T)',
  '(;_;)',
  '(;_:)',
  '(:_;)',
  '(;O;)',
  '(ToT)',
  '(Ｔ▽Ｔ)',
  ';_;',
  ';-;',
  ';n;',
  ';;',
  'Q.Q',
  'T.T',
  'TnT',
  'QQ',
  'Q_Q',
  '(-.-)',
  '(-_-)',
  '(一一)',
  '(；一_一)',
  '(=^・・^=)',
  '=^_^=',
  '(._.)',
  '(?_?)',
  '<^!^',
  '^/^',
  '（*^_^*）',
  '§^.^§',
  '(^<^)',
  '(^.^)',
  '(^ム^)',
  '(^·^)',
  '(^.^)',
  '(^_^.)',
  '(^_^)',
  '(^J^)',
  '(*^.^*)',
  '^_^',
  '(#^.^#)',
  '（^—^）',
  '(^_^)/~',
  '(;_;)/~~~',
  '(^.^)/~~~',
  '(-_-)/~~~',
  '($··)/~~~',
  '(@^^)/~~~',
  '(T_T)/~~~',
  '(ToT)/~~~',
  '＼(^o^)／',
  '＼(-o-)／',
  'ヽ(^。^)ノ',
  'ヽ(^o^)丿',
  '(*^0^*)',
  '(*_*;',
  '(+_+)',
  '(@_@)',
  '(@_@。',
  '(＠_＠;)',
  '＼(◎o◎)／！',
  '(^^)v',
  '(^_^)v',
  '（\'-\'*)',
  '(＾ｖ＾)',
  '(＾▽＾)',
  '(・∀・)',
  '(´∀`)',
  '(⌒▽⌒）',
  '\\(^o^)/',
  '(~_~)',
  '(-_q)',
  '(ーー゛)',
  '(^_^メ)',
  '(-_-メ)',
  '(~_~メ)',
  '(－－〆)',
  '(・へ・)',
  '(｀´)',
  '<`～´>',
  '<`ヘ´>',
  '(ーー;)',
  'φ(..)',
  '(＾ｖ＾)',
  '(＾ｕ＾)',
  '(＾◇＾)',
  '( ^)o(^ )',
  '(^O^)',
  '(^o^)',
  '(^○^)',
  ')^o^(',
  '(*^▽^*)',
  '(✿◠‿◠)',
  '°o°',
  '°O°',
  ':O',
  'o_O',
  'o_0',
  'o.O',
  '(o.o)',
  'oO',
  '(*°∀°)=3',
  '(°◇°)',
  '¯\\_(ツ)_/¯',
  '¯\\(°_o)/¯',
  '(\'A`)',
  '(︶｡︶✽)',
  'UwU',
  'OwO'
]; 